import React, { useState, useEffect } from "react";
import FloatingCta from "./FloatingNotification";
import { db } from "../../config/FirebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";
import "./FloatingNotificationAdmin.css";
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { whatsappLink } from "../../config/FirebaseConfig";
import { FaLongArrowAltRight } from "react-icons/fa";

const FloatingNotificationAdmin = () => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState({
    title: "",
    subtitle: "",
    ctaText: "",
    isActive: true,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, "config", "notification");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setNotification({
            title: docSnap.data().title || "",
            subtitle: docSnap.data().subtitle || "",
            ctaText: docSnap.data().ctaText || "",
            isActive:
              docSnap.data().isActive !== undefined
                ? docSnap.data().isActive
                : true,
          });
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNotification((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const saveSettings = async () => {
    try {
      await setDoc(doc(db, "config", "notification"), notification);
      alert("Configurações salvas com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar configurações:", error);
      alert("Erro ao salvar configurações");
    }
  };

  return (
    <div className="floating-notification-admin">
      <button onClick={() => navigate("/admin")} className="back-button">
        <AiOutlineArrowLeft /> Voltar
      </button>

      <h2>Configurações da Notificação Flutuante</h2>

      <div className="form-group">
        <label>
          Título:
          <input
            type="text"
            name="title"
            value={notification.title}
            onChange={handleChange}
          />
        </label>
      </div>

      <div className="form-group">
        <label>
          Subtítulo:
          <input
            type="text"
            name="subtitle"
            value={notification.subtitle}
            onChange={handleChange}
          />
        </label>
      </div>

      <div className="form-group">
        <label>
          Texto do botão:
          <input
            type="text"
            name="ctaText"
            value={notification.ctaText}
            onChange={handleChange}
          />
        </label>
      </div>

      <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            name="isActive"
            checked={notification.isActive}
            onChange={handleChange}
          />
          Notificação ativa
        </label>
      </div>

      {isLoading ? (
        <p className="loading">Carregando configurações...</p>
      ) : (
        <>
          <h3>Pré-visualização:</h3>
          {/* <div className="preview-container">
            <div className="preview-content">
            </div>
            </div>  */}
            <div className="floating-notification-container visible">
              <div className="floating-notification">
                <button
                  className="close-button"
                  aria-label="Close notification"
                >
                  <IoMdClose size={16} color="#4a5568" />
                </button>

                <div className="notification-content">
                  <span className="notification-subtitle">
                    {notification.subtitle}
                  </span>
                  <span className="notification-title">
                    {notification.title}
                  </span>
                </div>

                <Link
                  to={whatsappLink}
                  className="cta-button"
                  aria-label="Call to action"
                >
                  {notification.ctaText}
                  <FaLongArrowAltRight className="cta-icon" />
                </Link>
              </div>
            </div>

          <button onClick={saveSettings} className="save-button">
            Salvar Configurações
          </button>
        </>
      )}
    </div>
  );
};

export default FloatingNotificationAdmin;
